import { useLayoutEffect, useState } from "react";

/**
 * Altura para que un elemento llegue hasta el final de la ventana, dejando `bottomGap`
 * px de aire. Devuelve un `calc()` listo para `height`/`minHeight`, o null hasta medir.
 * Se usa en los tableros kanban para que las columnas ocupen la pantalla aunque haya
 * pocas tarjetas.
 */
export function useViewportBottomHeight(element, bottomGap = 40) {
  const [top, setTop] = useState(null);

  useLayoutEffect(() => {
    if (!element) return undefined;
    const measure = () => setTop(element.getBoundingClientRect().top + window.scrollY);
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [element]);

  return top === null ? null : `calc(100vh - ${Math.round(top + bottomGap)}px)`;
}
